import { Time } from 'app/shared/models';
import { minutesToMilliseconds } from 'app/shared/utils';

import { AppMode } from './app-mode';
import { InputMode } from './input-mode';

export interface AppSettings {
    appMode: AppMode;
    inputModes: InputMode[];
    masterDataCacheDurationInMs: number;
    scanFlowRegistrationSubmitIntervalMs: number;
    userSessionExpirationTime: Time;
}

export const defaultAppMode: AppMode = 'multi-user';
export const defaultInputMode: InputMode = 'manual';
export const defaultInputModeList: InputMode[] = [defaultInputMode];
export const defaultUserSessionExpirationTime = { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
export const defaultMasterDataCacheDurationInMs = minutesToMilliseconds(1);
export const defaultScanFlowRegistrationSubmitIntervalMs = 60000;
export const defaultAppSettings = (): AppSettings => ({
    appMode: defaultAppMode,
    inputModes: defaultInputModeList,
    masterDataCacheDurationInMs: defaultMasterDataCacheDurationInMs,
    scanFlowRegistrationSubmitIntervalMs: defaultScanFlowRegistrationSubmitIntervalMs,
    userSessionExpirationTime: defaultUserSessionExpirationTime,
});
